import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-project-cycle-pv.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-project-cycle-pv.component.scss?ngResource";
import { Component } from "@angular/core";
import { ApplicationSearchConstants } from "../../../application-search-constants";
import { SharedConstants } from "../../../../../../shared/constants/shared.constants";
import { FormControl, FormGroup } from "@angular/forms";
import { ApplicationSearchService } from "../../../../shared/application-search.service";
import { AflaModuleStrategyService } from "../../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../../app-controller.service";
import { AlertType } from "../../../../../../shared/models/alert";
import { AutoUnsub } from "../../../../../../shared/decorators/autounsub.decorator";
let SearchprojectCyclePvComponent = class SearchprojectCyclePvComponent {
    applicationSearchService;
    aflaModuleStrategyService;
    appController;
    valuationRunLabel = ApplicationSearchConstants.FORM_CONTROLS.valuationRunLabel;
    valuationRunFormControl = ApplicationSearchConstants.FORM_CONTROLS.valuationRunFormControl;
    placeholder = SharedConstants.SEARCH_BY_DEFAULT;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    subscription;
    valuationRunForm;
    valuationRunList;
    applicationSearchCallback;
    constructor(applicationSearchService, aflaModuleStrategyService, appController) {
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        //super();
    }
    ngOnInit() {
        this.setUpForm();
        this.subscription = this.applicationSearchService.getValuationRunsForModule(Number(this.appController.selectedModuleID))
            .subscribe((types) => {
            this.valuationRunList = types.value;
        });
    }
    ngOnDestroy() {
    }
    searchApplication($event) {
        const valRun = this.valuationRunForm.get(this.valuationRunFormControl).value;
        if (valRun !== "") {
            this.applicationSearchCallback(this.applicationSearchService.searchByValuationRun(valRun, Number(this.appController.selectedModuleID), this.aflaModuleStrategyService));
        }
        else {
            this.appController.showMessage(`${SharedConstants.NO_OPTION_SELECTED}`, AlertType.Warning);
        }
    }
    setUpForm() {
        this.valuationRunForm = new FormGroup({
            valuationRunFormControl: new FormControl("")
        });
    }
    static ctorParameters = () => [
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService }
    ];
};
SearchprojectCyclePvComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-project-cycle-pv",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], SearchprojectCyclePvComponent);
export { SearchprojectCyclePvComponent };
